import React, { FC, ReactNode } from 'react';

import OverlayFormFooter from '../OverlayFormFooter/OverlayFormFooter';

export interface InformationOverlayProps {
  headline?: string;
  description: string;
  imageTitle: string;
  image: ReactNode;
  ctaLabel: string;
  onButtonClick: () => void;
}

const InformationOverlay: FC<
  React.PropsWithChildren<InformationOverlayProps>
> = ({ description, imageTitle, image, ctaLabel, onButtonClick }) => {
  const className = {
    wrapperStyle: 'pb-[150px]',
    descriptionStyle: 'mb-20px text-p1',
    imageTitleStyle: 'block mb-15px text-p3',
  };

  const { wrapperStyle, descriptionStyle, imageTitleStyle } = className;

  return (
    <div className={wrapperStyle}>
      <p className={descriptionStyle}>{description}</p>
      <span className={imageTitleStyle}>{imageTitle}</span>
      {image && image}
      <OverlayFormFooter buttonText={ctaLabel} onButtonClick={onButtonClick} />
    </div>
  );
};

export default InformationOverlay;
